export default __webpack_public_path__ + "./images/gg.bdf434c9.png";